$(document).ready(function(){

  $(document).on("click",".gotoStep1",function() {
    $(".step2").hide();
    $(".finalResults").hide();
    $(".step1").show(); 
    $('.listedResultsGrid').slick('unslick');
    $("input:radio").prop('checked', false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }); 

  $(document).on("click",".gotoStepbefore2",function() {
    $(".step1").hide();
    $(".stepBefore2").show();
  });

  function stepTwoDetails(){
    $(".stepBefore2").hide();
    $(".step3").hide();
    $(".step3 .singleOption").show();
    $(".listedSubOptions, .innerBack").hide();    
    $(".step2").show();
    $("input:radio").prop('checked', false);
    window.scrollTo({ top: 0, behavior: 'smooth' });    
  }

  // $(document).on("click","button.needsclick",function() {
  //   setTimeout(function() { 
  //     $(".hideForNow").show();
  //   }, 500);    
  // });
  
  $(document).on("click",".gotoStep2, .needsclick p span a, .kl-private-reset-css-Xuajs1 pre span a span",function() {
    stepTwoDetails();
  }); 

  $(document).on("click",".gotoStep3",function() {

    if (!$("input[name='age-group']:checked").val()) {
       $('.step2 .textError').show();
        return false;
    }
    else {
      $(".step2").hide();
      $(".step3").show();
      $("input:radio").prop('checked', false);      
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }    
  }); 

  $(document).on("click",".gotoStep4",function() {

    if (!$("input[name='main-selection']:checked").val() || !$("input[name='main-sub-selection']:checked").val()) {
       $('.step3 .textError').show();
        return false;
    }
    else {
      $(".step3").hide();
      $(".finalResults").show();
      $('.listedResultsGrid').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        responsive: [
          {
            breakpoint: 768,
             settings: {
              slidesToShow: 1,
              dots: true
             }
          }
        ]
      });  
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }    
  });   

    $('input:radio[name="age-group"]').change(
      function(){
        $('.step2 .textError').hide();
        if ($(this).is(':checked') && $(this).val() == 'under-18') {
          $('.underText').show();
          $('.gotoStep3').attr("disabled", true);
        }else{
          $('.underText').hide();
          $('.gotoStep3').attr("disabled", false);
        }
    }); 

    $('input:radio[name="main-selection"]').change(
      function(){
        $('.step3 .textError').hide();
        if ($(this).is(':checked')) {
          var radioValue = $(this).val();
          $(".listedRecommendedProducst .singleBlockProducts").each(function(index,item){
            var resultId = $(this).attr("id");
            if(radioValue == resultId){ 
              $(".singleBlockProducts").removeClass("active");
              $(this).addClass("active");
            }
          });  
          $(".listedRecommText .singleRecommText").each(function(index,item){
            var textId = $(this).attr("id");
            if(radioValue == textId){ 
              $(".singleRecommText").removeClass("active");
              $(this).addClass("active");
            }
          });            
          
        }
    });   
  
   $(document).on("click",".step3 .singleOption",function() {
     $(".listedSubOptions, .step3 .singleOption").hide();
     $(this).show();
     $(this).next(".listedSubOptions").show();
     $(".innerBack").show();
   });
  
  $(document).on("click",".innerBack",function() {
    $(".step3 .singleOption").show();
    $("input:radio").prop('checked', false);
    $(".listedSubOptions, .innerBack").hide();
  });

  
    $('input:radio[name="main-sub-selection"]').change(
      function(){
        $('.step3 .textError').hide();
        if ($(this).is(':checked')) {
          var subRadioValue = $(this).val();
          $(".mainRecommendedProduct .singleMainProduct").each(function(index,item){
            var subResultId = $(this).attr("data-suboption-id");
            if(subRadioValue == subResultId){ 
              $(".singleMainProduct").removeClass("active");
              $(this).addClass("active");
              var parentProductId = $(".grid-product", $(this)).attr("data-id");
              $(".singleBlockProducts.active .grid-product").each(function(index,item){
                var childProductId = $(this).attr("data-id");
                if(parentProductId == childProductId){ 
                  $(".singleBlockProducts .grid-product").removeClass("matched");
                  $(this).addClass("matched");
                }
              });                          
            }
          });          
        }
    });  

  





  
});